import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppButton, AppTextField } from "../../../components/form";
import { AppSlideOver } from "../../../components/layout";

type Props = {
  open: boolean;
  indexName?: string;
  analysisText: string;
  analysisApproved?: boolean;
  generating?: boolean;
  saving?: boolean;
  onChange: (value: string) => void;
  onClose: () => void;
  onGenerate: () => void;
  onApprove: () => void;
};

export default function GuideAnalysisPanel({
  open,
  indexName,
  analysisText,
  analysisApproved,
  generating,
  saving,
  onChange,
  onClose,
  onGenerate,
  onApprove,
}: Props) {
  const { t } = useTranslation();

  return (
    <AppSlideOver
      open={open}
      onClose={onClose}
      size="lg"
      title={
        <>
          {t("guide.analysisPanelTitle")}
          {indexName ? (
            <Typography component="span" variant="caption" color="text.secondary" display="block">
              {indexName}
            </Typography>
          ) : null}
        </>
      }
      actions={
        <>
          <AppButton variant="outlined" onClick={onClose}>
            {t("common.cancel")}
          </AppButton>
          <AppButton
            variant="contained"
            color="success"
            onClick={onApprove}
            disabled={saving || generating || !analysisText.trim()}
          >
            {saving ? t("common.loading") : t("guide.approveAnalysis")}
          </AppButton>
        </>
      }
    >
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          {t("guide.analysisPanelHint")}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <AppButton variant="outlined" onClick={onGenerate} disabled={generating}>
            {generating ? t("common.loading") : t("guide.generateAnalysis")}
          </AppButton>
          {analysisApproved && (
            <Typography variant="body2" color="success.main">
              {t("guide.analysisApproved")}
            </Typography>
          )}
        </Stack>
        <AppTextField
          label={t("guide.analysisDocument")}
          value={analysisText}
          onChange={(e) => onChange(e.target.value)}
          multiline
          minRows={18}
          fullWidth
          disabled={generating}
        />
      </Stack>
    </AppSlideOver>
  );
}
